module.exports = __webpack_public_path__ + "img/icons8-profiles-100 1 copy.52c0070b.svg";